<section class="begin-page-slider">
  <!-- main image container -->
  <div
    class="begin-page-slider__main-image-container"
    [ngClass]="{ '!w-11/12 rtl:!mr-320 ltr:!ml-320': isFullWidth() }">
    <!-- main image -->
    @if (showMainImage) {
      <img
        [@sliderImageChange]="'fadeIn'"
        class="begin-page-slider__main-image"
        [ngClass]="{ '!w-4/5 object-fill': isFullWidth() }"
        [ngSrc]="
          mainImage?.cropped_url?.toLowerCase() || mainImage?.url
            ? (mainImage?.cropped_url?.toLowerCase() || mainImage?.url
              | imageSource)
            : 'assets/images/no-card-image-md.svg'
        "
        width="938"
        height="554"
        priority
        alt="" />
    }

    <!-- next image button -->
    <button class="slider-button" (click)="nextImage()"></button>
  </div>

  <!-- other images -->
  @if (otherImage && showMainImage) {
    <div
      class="begin-page-slider__other-images-container"
      [ngClass]="{ '!right-0': isFullWidth() }">
      <img
        [@sliderImageChange]
        class="begin-page-slider__other-images"
        [ngClass]="{ '!w-240': isFullWidth() }"
        [ngSrc]="
          otherImage?.cropped_url?.toLowerCase() || otherImage?.url
            ? (otherImage?.cropped_url?.toLowerCase() || otherImage?.url
              | imageSource)
            : 'assets/images/no-card-image-md.svg'
        "
        width="938"
        height="476"
        alt="" />
    </div>
  }
</section>
